import { Response } from "openai/resources/responses/responses";
import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";

export function getResponse(responseId: string): Promise<Response> {
  const url = `${ApiEndpoints.toolCall}/response/${responseId}`;
  const request = setHeaderOptions({
    method: "GET",
  });
  return fetchData<Response>(url, request);
}
